import { render, staticRenderFns } from "./CompanyRecordEntry.vue?vue&type=template&id=2f906aba&"
import script from "./CompanyRecordEntry.vue?vue&type=script&lang=js&"
export * from "./CompanyRecordEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports